import { instance } from "./instance";
import { Favorite } from "../types/favorite";

const axios = instance("USER_PREFERENCE");

export const postFavorite = async (data: Favorite): Promise<Favorite> => {
    const response = await axios.post<Favorite>(`favorite`, data);
    return response.data;
}

export const deleteFavorite = async (data: Favorite): Promise<Favorite> => {
    const response = await axios.delete<Favorite>(`favorite/${data.contentType}/${data.contentId}`);
    return response.data;
}